export const TIME_PERIODS = {
  THIS_MONTH: 2,
};
